/* @flow weak */

const React = require('react');
const Reflux = require('reflux');
const Config = require('../../configs/Config.js');

const _ = require('lodash');

const VisualizationStore = require('../../stores/VisualizationStore.jsx');
const ProductStore = require('../../stores/ProductStore.jsx');
const AnswerStore = require('../../stores/AnswerStore.jsx');

const PriceSection = require('./PriceSection.jsx');
const StaticImagePreviewSection = require('./StaticImagePreviewSection.jsx');
const LiquifireImagePreviewSection = require('./LiquifireImagePreviewSection.jsx');
const ReviewSection = require('./ReviewSection.jsx');
const DetailSection = require('./DetailSection.jsx');

const Dialog = require('../renderers/DialogRenderer.jsx');

const PreviewSection = React.createClass({
  mixins: [
    Reflux.connect(VisualizationStore, 'visData'),
    Reflux.connect(ProductStore, 'productData'),
    Reflux.connect(AnswerStore, 'answers')
  ],

  handleEnlargeImage(image) {
    this.refs.largeImgDialog.showDialog(image);
  },

  getImagePreviewSection() {
    let imagePreviewType = _.get(this.state.productData, 'metadata.ImageRendererType') || Config.images.imageRendererType;

    if (!__PROD__) {
      // Feature Flag to force Liquid Pixels rendering in non-production environments.
      if (!!_.get(this.state.productData, 'metadata.FFForceLiquidPixelRendering')) {
        imagePreviewType = 'liquifire';
      }
    }

    return (imagePreviewType && imagePreviewType === 'liquifire') ?
      <LiquifireImagePreviewSection
        productData={this.state.productData}
        answers={this.state.answers}
        enlargeImage={this.handleEnlargeImage}
        visData={this.state.visData} /> :
      <StaticImagePreviewSection
        productData={this.state.productData}
        answers={this.state.answers} />;
  },

  fixedPosition: false,

  render() {
    let visData = this.state.visData;
    let imagePreviewSection = this.getImagePreviewSection();

    let previewStyle = null;

    // compensate for fixed header if one exists for the current vendor
    let fixedHeaderHeight = Config.fixedHeaderHeightSmall;
    if (window.innerWidth >= Config.breakpoints.small) fixedHeaderHeight = Config.fixedHeaderHeightMedium;
    if (window.innerWidth >= Config.breakpoints.medium) fixedHeaderHeight = Config.fixedHeaderHeightLarge;

    if (window.innerWidth >= Config.breakpoints.small && 
        visData &&
        visData.previewRect && 
        visData.mainRect && 
        visData.mainRect.top < fixedHeaderHeight) {

      let mainHeight = visData.mainRect.bottom - visData.mainRect.top;
      let previewHeight = visData.previewRect.bottom - visData.previewRect.top;

      if (previewHeight < mainHeight) {
        let mainWidth = visData.mainRect.right - visData.mainRect.left;
        let mainTop = visData.mainRect.top;
        let mainBottom = visData.mainRect.bottom;

        // Browsers on iPad don't calculate the bounding box coordinates of fixed-position elements correctly during scroll.
        // To compensate, if the preview section position is set to fixed, let's use it's height as a substitute for bottom position.
        let previewBottom = !this.fixedPosition ? visData.previewRect.bottom : (visData.previewRect.height + fixedHeaderHeight);
        // Similar to above, if the position is fixed, just use a value of 0 for the top position.
        let previewTop = this.fixedPosition ? 0 : visData.previewRect.top;

        if (Math.round(mainBottom) <= Math.round(previewBottom) && Math.round(previewTop) <= Math.round(fixedHeaderHeight)) {
          this.fixedPosition = false;
          previewStyle = {
            width: `${mainWidth * Config.previewSectionWidthMultiplier}px`,
            position: 'absolute',
            top: 'auto',
            bottom: '0px'
          };
        } else {
          this.fixedPosition = true;
          previewStyle = {
            width: `${mainWidth * Config.previewSectionWidthMultiplier}px`,
            position: 'fixed',
            top: fixedHeaderHeight + 'px',
            bottom: 'auto'
          };
        }
      }
    } else {
      this.fixedPosition = false;
    }

    return (
      <div className="uc-preview-section-container">
        <div id="uc-preview-section" className="uc-preview-section" style={previewStyle}>
          {imagePreviewSection}

          <div className="uc-pricesection-product-name">
            {Config.features.previewPrice ?
              <PriceSection />
              : null}

            {Config.features.previewName ?
              <div className="uc-product-name">
                {ProductStore.getProductName()}
              </div>
              : null}
          </div>
          
          {Config.features.selectionSummary ?
            <ReviewSection answers={this.state.answers} />
            : null}
          
          {Config.features.productDetailsPosition === 'preview' ?
            <DetailSection productData={this.state.productData} />
            : null}
        </div>

        <Dialog
          ref='largeImgDialog'
          size='full'
          class='uc-preview-dialog'
          containerStyle={{ 
            textAlign: 'center',
            background: 'transparent',
            padding: '10px'
          }}/>
      </div>
    );
  }
});

module.exports = PreviewSection;



// WEBPACK FOOTER //
// ./src/base/scripts/components/section/PreviewSection.jsx